export const hasUpperCase = (str :string): boolean => str !== str.toLowerCase();
export const hasLowerCase = (str :string): boolean => str !== str.toUpperCase();
export const hasNumbers = (str :string): boolean => /[0-9]/.test(str);
export const hasSpicialChar = (str :string): boolean => /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
